import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
export default function Book(props) {
    return (_jsx(_Fragment, { children: _jsx(Button, { fullWidth: true, sx: { my: 1 }, variant: "contained", children: "Maak een afspraak" }) }));
}
